import * as React from "react";

export default function WirelessIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect y="0.746216" width="48" height="47.9999" rx="7.92" fill="#F8DBEB" />
      <path
        d="M23.9986 33.4461C23.7502 33.4461 23.5486 33.6477 23.551 33.8961C23.5498 34.1445 23.7514 34.3461 23.9998 34.3461C24.2482 34.3461 24.4498 34.1445 24.4498 33.8961C24.4498 33.6477 24.2482 33.4461 23.9986 33.4461"
        stroke="#C13683"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1084 24.7462C20.0188 20.2426 27.9784 20.2426 32.8888 24.7462"
        stroke="#C13683"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5117 19.711C18.4081 13.6246 29.5897 13.6246 36.4861 19.711"
        stroke="#C13683"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6943 29.3314C21.6235 26.4178 26.3743 26.4178 29.3035 29.3314"
        stroke="#C13683"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
